var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"button",attrs:{"elevation":"0"},on:{"click":_vm.click}},[_c('v-icon',[_vm._v("$unlockIcon")]),_vm._v(" "+_vm._s(_vm.$t("subscribeBanner.button.text"))+" ")],1)}
var staticRenderFns = []

export { render, staticRenderFns }